import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import LandingPageHeader from "./LandingPageHeader";
import styles from "./LandingPage.module.css";
import prasadamLogo from "../../assets/prasadamLogo.svg";
import mainCoursel1 from "../../assets/mainCoursel1.jpg";
import mainCoursel2 from "../../assets/mainCoursel2.jpg";
import mainCoursel3 from "../../assets/mainCoursel3.jpg";
import mainCoursel4 from "../../assets/mainCoursel4.jpg";
import { Box, Button, Typography } from "@mui/material";
import AboutUsComponent from "./AboutUsComponent";
import MustTryComponent from "./MustTryComponent";
import FooterComponent from "./FooterComponent";
import { SwiggyIcon, ZomatoIcon } from "../../svgImage";
import HeaderNoteStrip from "./HeaderNoteStrip";
import heroSection1 from "../../assets/hero-section/heroSection1.jpg";
import heroSection2 from "../../assets/hero-section/heroSection2.jpg";
import heroSection3 from "../../assets/hero-section/heroSection3.jpg";
import heroSection4 from "../../assets/hero-section/heroSection4.jpg";
import heroSection5 from "../../assets/hero-section/heroSection5.jpg";
import Gifting from "./Gifting";
import Umami from "./Umami";
import ContactUs from "./ContactUs";
import CustomerLove from "./CustomerLove";

const LandingPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const heroSectionImage = [
    heroSection1,
    heroSection2,
    heroSection3,
    heroSection4,
    heroSection5,
  ];

  const storeLink = process.env.REACT_APP_PRASADAM_STORE_LINK;
  const zomatoLink = "https://zomato.onelink.me/xqzv/mgiamoe8";
  const swiggyLink = "https://www.swiggy.com/menu/1106133?source=sharing";

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeout(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === heroSectionImage.length - 1 ? 0 : prevIndex + 1
        );
      }, 500);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const handleOpenStore = (type) => {
    if (type === "orderNow") {
      window.location.href = "https://wa.me/c/918980593216";
    } else if (type === "zomato") {
      window.open(zomatoLink, "_blank");
    } else if (type === "swiggy") {
      window.open(swiggyLink, "_blank");
    }
  };

  return (
    <Grid container>
      <Grid size={12}>
        <HeaderNoteStrip />
      </Grid>
      <Grid size={12}>
        <LandingPageHeader />
      </Grid>
      <Grid size={12} id="home">
        <Grid container>
          <Grid className={styles.leftContent}>
            <Box className={styles.innerContent}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item>
                  <img src="/prasadamNewLogo.svg" alt="prasadam-logo" />
                </Grid>
                <Grid item>
                  <Typography align="center" className={styles.quotestext}>
                    Each bite, a request for more delight
                  </Typography>
                </Grid>
                <Grid item>
                  <Box display={"flex"} columnGap={2}>
                    <Button
                      variant="contained"
                      className={styles.orderNowButton}
                      onClick={() => handleOpenStore("orderNow")}
                    >
                      Order now!
                    </Button>
                  </Box>
                </Grid>

                <Grid item>
                  <Typography
                    className={styles.quotestext}
                    style={{ textAlign: "center" }}
                  >
                    Now you can order from your favorite <br /> food ordering
                    apps
                  </Typography>
                  <Box display={"flex"} gap={"16px"} mt={2}>
                    <button
                      className={styles.orderOnButton}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenStore("zomato")}
                    >
                      Order on
                      <ZomatoIcon
                        height="32px"
                        width="32px"
                        className={styles.cursor}
                      />
                    </button>
                    <button
                      className={styles.orderOnButton}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenStore("swiggy")}
                    >
                      Order on
                      <SwiggyIcon className={styles.cursor} />
                    </button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid className={styles.rightContent}>
            {/* <div className={styles.mainCoursel}>
              <img
                src={images[currentIndex]}
                alt={`Slide ${currentIndex + 1}`}
                style={{ width: "100%", height: "100%" }}
              />
            </div> */}
            {heroSectionImage.map((slide, i) => (
              <div
                key={i}
                style={{
                  position: "absolute",
                  backgroundImage: `url(${slide})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: i === currentIndex ? 1 : 0,
                  transition: "opacity 1.2s ease-in-out", // <-- critical for fade effect
                }}
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid size={12} id="about" mt={"100px"}>
        <AboutUsComponent />
      </Grid>
      <Grid size={12} id="mustTry">
        <MustTryComponent />
      </Grid>
      <Grid size={12} id="umami">
        <Umami />
      </Grid>
      <Grid size={12} id="gifting">
        <Gifting />
      </Grid>

      <Grid size={12} id="loveFrom">
        <CustomerLove />
      </Grid>
      <Grid size={12} id="contact">
        <ContactUs />
      </Grid>

      <Grid size={12}>
        <FooterComponent />
      </Grid>
    </Grid>
  );
};

export default LandingPage;
